"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IN_PERSON = exports.VIDEO = exports.PHONE = void 0;
exports.PHONE = 'phone';
exports.VIDEO = 'video';
exports.IN_PERSON = 'in_person';
//# sourceMappingURL=VisitTypes.js.map